import * as React from 'react';
import { styled } from '@glitz/react';
import { bareListDecorator } from 'webapp/decorators/list';
import { createMaxSmallViewportDecorator, createMinMediumViewportDecorator } from 'webapp/viewport';
import { translate } from '@avensia/excite';
import { headingDecorator } from 'webapp/decorators/heading';
import Link from 'webapp/components/Link';

type PropType = {
  links: NordicNest.Api.RelatedProductListingLink[];
};

export const ProductListingLinks = (props: PropType) => {
  return (
    <Base>
      <Heading>{translate(t => t.inspiration.relatedProductListingLinksHeader)}</Heading>
      <List>
        {props.links.map(link => (
          <li key={link.url}>
            <ProductListingLink to={link.url}>{link.name}</ProductListingLink>
          </li>
        ))}
      </List>
    </Base>
  );
};

const Base = styled.div(
  createMinMediumViewportDecorator({
    padding: { bottom: t => t.spacing.l },
  }),
  {
    textAlign: 'center',
    padding: { x: t => t.spacing.m, bottom: t => t.spacing.m },
  },
);

const Heading = styled.h2(
  headingDecorator,
  createMaxSmallViewportDecorator({
    fontSize: t => t.fontSize.s,
  }),
  {
    marginBottom: t => t.sharedSpacing.l,
  },
);

const List = styled.ul(bareListDecorator, {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  columnGap: t => t.spacing.m,
  rowGap: t => t.spacing.xs,
});

const ProductListingLink = styled(Link, {
  textDecoration: 'underline',
  ':hover': {
    textDecoration: 'underline',
  },
});
